import React from 'react';
import { Svg, G, Path } from '@react-pdf/renderer';

const RadioButonChecked = () => (
  <Svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><Path fill="black" d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-3a5 5 0 1 1 0-10 5 5 0 0 1 0 10z"/></Svg>

);

export default RadioButonChecked;
